import { useEffect, useState } from "react";

import { getTHEOplayerConfig } from "./StreaminngUtility";
import {
  getTheoPlayerImportSource,
  getTHEOplayerRuntimeWithLibraryLocation,
} from "./videojsComponent/theoplayerRuntime";

import type {
  ResolvedTHEOPlayerRuntime,
  THEOPlayerRuntime,
} from "./videojsComponent/theoplayerRuntime";

const POLLING_INTERVAL_MS = 100;

export const useGetTHEOPlayerRuntime = (): ResolvedTHEOPlayerRuntime | null => {
  const [resolved, setResolved] = useState<ResolvedTHEOPlayerRuntime | null>(
    null
  );

  useEffect(() => {
    if (getTheoPlayerImportSource() === "node-module") {
      void getTHEOplayerRuntimeWithLibraryLocation().then(setResolved);
      return;
    }

    // TODO: node-moduleへの移行完了後、cdn-windowパスごと削除する
    // cdn-windowの場合、window.THEOplayerは非同期でセットされるためpollingで待つ
    const { libraryLocation } = getTHEOplayerConfig();
    let timeoutId: ReturnType<typeof setTimeout>;

    const poll = () => {
      if (window.THEOplayer) {
        setResolved({
          THEOplayer: window.THEOplayer as unknown as THEOPlayerRuntime,
          libraryLocation,
        });
        return;
      }
      timeoutId = setTimeout(poll, POLLING_INTERVAL_MS);
    };

    poll();

    return () => clearTimeout(timeoutId);
  }, []);

  return resolved;
};
